export default __webpack_public_path__ + "static/media/Mining_icon.e857c166.svg";